import React from "react";

const Copyright = () => {
  return (
    <React.Fragment>
      <div className="copyright">
        <div className="container">
          <div className="row">
            <div className="col-sm-12">
              <p>
                Copyrights © 2022 Noida Power Company Limited. All Rights
                Reserved.
              </p>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default Copyright;
